import React from 'react';
import { Text } from '@chakra-ui/react';
import { SectionContainer } from '../SectionContainer';
import { ScrollReveal } from '../ScrollReveal';

export default function ReframeSection() {
  return (
    <SectionContainer bg="bg.800" id="reframe" aria-labelledby="reframe-heading">
      <ScrollReveal>
        <Text
          id="reframe-heading"
          as="blockquote"
          fontFamily="'Space Grotesk', sans-serif"
          fontWeight="500"
          fontSize={{ base: 'clamp(1.25rem, 4vw, 1.8rem)', md: 'clamp(1.5rem, 3vw, 2.2rem)' }}
          lineHeight="1.45"
          color="text.primary"
          textAlign="center"
          maxW="860px"
          mx="auto"
          letterSpacing="-0.01em"
        >
          Other platforms chase incremental gains inside your company.{' '}
          <Text as="span" color="brand.400">
            yetzira.ai grows a new one
          </Text>{' '}
          — an organization designed, staffed, run, and scaled entirely by AI.
        </Text>
      </ScrollReveal>
    </SectionContainer>
  );
}
